import React, { useState } from "react";
import bs58 from 'bs58';

export default function ContactContextMenu({ 
  contact, 
  onClose, 
  onDelete, 
  onRename, 
}) {
  const [name, setName] = useState(contact.name || "");

  const trimmed = name.trim();
  const isChanged = trimmed !== contact.name && trimmed !== "";

  const handleRename = () => {
    if (isChanged) {
      onRename({
        identityViewPublicKey: contact.identityViewPublicKey,
        name: trimmed,
      })
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "#000",
        color: "#fff",
        padding: "1rem",
        zIndex: 2000,
        borderBottom: "1px solid #333",
      }}
    >
      <div style={{ marginBottom: "1rem" }}>
        <h2 style={{ margin: 0, fontSize: "1.25rem" }}>Edit Contact</h2>
      </div>

      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && isChanged) handleRename();
        }}
        placeholder="Contact Name"
        style={{
          width: "100%",
          padding: "0.5rem",
          marginBottom: "0.5rem",
          borderRadius: "6px",
          border: "none",
          backgroundColor: "#111",
          color: "#4e8cff",
          fontSize: "1rem",
        }}
      />

      <div style={{ fontSize: "0.85rem", color: "#aaa", marginBottom: "1rem", wordBreak: "break-all" }}>
        {bs58.encode(contact.identityViewPublicKey)}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
        <button
          onClick={onClose}
          style={{
            flex: 1,
            padding: "0.5rem",
            backgroundColor: "#111",
            color: "#fff",
            border: "1px solid #444",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>

        <button
          onClick={() => onDelete(contact)}
          style={{
            flex: 1,
            padding: "0.5rem",
            backgroundColor: "#330000",
            color: "#f66",
            border: "1px solid #f66",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Delete
        </button>

        <button
          onClick={handleRename}
          disabled={!isChanged}
          style={{
            flex: 1,
            padding: "0.5rem",
            backgroundColor: isChanged ? "#4e8cff" : "#222",
            color: isChanged ? "#fff" : "#888",
            border: "none",
            borderRadius: "6px",
            cursor: isChanged ? "pointer" : "not-allowed",
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
}